import * as React from "react"
import { useSelector } from "react-redux"
import { AppState } from "../../store/types"
import { ParkingAvailabilityTile } from "./ParkingAvailabilityTile"

export function LocationListing() {
  const { parkingAvailabilityModel } = useSelector(
    (state: AppState) => state.devDocs
  )

  if (parkingAvailabilityModel === undefined) {
    return <></>
  }
  return (
    <div className="location-wrapper mx-auto p-2">
      <ParkingAvailabilityTile
            {...parkingAvailabilityModel}
            key={parkingAvailabilityModel.id}
          />
    </div>
  )
}
